/**
 * The name a screen calls a client by in a sentence ("Remove a note"):
 * the preferred name when one is recorded,
 * else the first name, else the first word of the display name (a client
 * imported before the structured name, as the name editor reads it).
 * Null when there is no name at all; the sentence then says "this client".
 */
export function clientCallName(v: { preferredName: string | null; firstName: string | null; displayName: string }): string | null {
  const preferred = (v.preferredName ?? '').trim();
  if (preferred !== '') return preferred;
  const first = (v.firstName ?? '').trim();
  if (first !== '') return first;
  const word = v.displayName.trim().split(/\s+/)[0] ?? '';
  return word === '' ? null : word;
}
